import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { UniDriver } from '@wix/unidriver-core';

export interface MediaOverlayUniDriver<T> extends BaseUniDriver {
  hover: () => Promise<void>;
  getMediaUrl: () => Promise<string | null>;
  getMediaNode: () => Promise<T>;
  getSkin: () => Promise<string | null>;
  getHoverSkin: () => Promise<string | null>;
}

declare function mediaOverlayDriverFactory<T>(
  base: UniDriver,
  body?: UniDriver,
): MediaOverlayUniDriver<T>;
